// src/routes/ProtectedRoute.tsx

import { useAuth } from "@/contexts/Auth";
import { Navigate, Outlet } from "react-router-dom";
import { checkHasPermission } from "@/lib/permissions"; 

interface ProtectedRouteProps {
  requiredPermission: string;
}

const ProtectedRoute = ({ requiredPermission }: ProtectedRouteProps) => {
  const { usuario } = useAuth();

  // Aqui usamos a função que você moveu para o arquivo de permissões!
  const hasPermission = checkHasPermission(usuario?.permissoes, requiredPermission);


  if (!hasPermission) {
    return <Navigate to="/403" replace />;
  }

  // Se ele tiver a permissão, o <Outlet /> renderiza a rota filha.
  return <Outlet />;
};

export default ProtectedRoute;